var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-box filter--btn"},[_c('div',{staticClass:"icon-btn filter-icon-btn",attrs:{"id":"filter-btn"},on:{"click":_vm.handleOnOpenFilter}},[_c('FIcon',{attrs:{"name":"filter","size":"1.4rem"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }